const allowedUserIds = ["2D9BFUVY", "MN34OP56", "OP12QR34"]; 

export default allowedUserIds;
